import styled from 'styled-components';
import { Typ32 } from 'dc/Typ';
import Lab010 from 'dc/Lab010';
import IcoW02 from 'dc/IcoW02';

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const TextWrapper = styled.div`
  min-width: 0;
  margin-left: 16px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Name = styled(Typ32)`
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 22px;
  white-space: nowrap;
`;

export const Icon = styled(IcoW02)`
  margin-left: 16px;
`;

export const TimeLabel = styled(Lab010)``;
